import { createSelector } from 'reselect';
// @ts-expect-error module not typed
import { getFocusedThreadDetails } from '../../thread-details/selectors/getFocusedThreadDetails';
import { getVisitor } from 'conversations-thread-data/thread-details/public/operators';
export const getFocusedThreadVisitor = createSelector([getFocusedThreadDetails], getVisitor);